import InternalPubSub from '../services/internal-pub-sub/index';
import { eInternalEvents } from '../utils/enums';
import Global from '../global';

export default {
  reportUserActivityToSportProvider(){
    Global.logger.debug('Send KeepAlive to Kambi!!');
    InternalPubSub.publishEvent(eInternalEvents.KeepAliveSportProvider);
  }
};
